import { Service, Testimonial } from './types';

export const SERVICES: Service[] = [
  {
    id: '1',
    title: 'Paint Protection Film',
    description: 'Onzichtbare, zelfherstellende beschermlaag tegen steenslag en krassen.',
    icon: 'Shield'
  },
  {
    id: '2',
    title: 'Ceramic Coating',
    description: 'Extreme hydrofobe eigenschappen en diepe glans met jarenlange garantie.',
    icon: 'Droplets'
  },
  {
    id: '3',
    title: 'Paint Correction',
    description: 'Verwijderen van swirls en imperfecties voor een spiegelgladde finish.',
    icon: 'Sparkles'
  },
  {
    id: '4',
    title: 'Premium Wrapping',
    description: 'Volledige kleurverandering met de hoogste kwaliteit vinyls.',
    icon: 'Layers'
  }
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: '1',
    name: 'Alexander V.',
    car: 'Porsche 911 GT3',
    text: 'Ik ben extreem kritisch op mijn lak. Het team van Obsidian begreep precies wat nodig was. De PPF installatie is onzichtbaar.'
  },
  {
    id: '2',
    name: 'Marc de J.',
    car: 'Audi RS6',
    text: 'De keramische coating maakt wassen een droom. De auto ziet er na 6 maanden nog steeds uit alsof hij net uit de showroom komt.'
  },
  {
    id: '3',
    name: 'Sarah L.',
    car: 'Mercedes G-Class',
    text: 'Professioneel advies en geen onzin verhalen. Het resultaat overtrof mijn verwachtingen.'
  }
];